module.exports = __webpack_public_path__ + "img/img17.5f4971b5.png";